const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/dashboard")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context
  }) => {
    if (context.session) {
      const id = context.session.user.email.split("@")[0];
      throw redirect({
        href: `/profile/${id}`
      });
    }
    throw redirect({
      to: "/{-$locale}"
    });
  },
  preload: true
});